var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Navbar'),_c('v-main',{staticClass:"pt-16",staticStyle:{"height":"100%"}},[_c('v-container',{staticClass:"pa-0",staticStyle:{"margin-top":"16px"}},[_c('router-view')],1)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }